import React from 'react'

export const ProductAttribute = ({ title, value }: { title: string; value: any }) => (
  <p style={{ fontSize: '1.1em' }}>
    <b>{`${title}: `}</b>
    {value}
  </p>
)
